import { render, staticRenderFns } from "./squad.vue?vue&type=template&id=23415126&scoped=true&"
import script from "./squad.vue?vue&type=script&lang=js&"
export * from "./squad.vue?vue&type=script&lang=js&"
import style0 from "./squad.vue?vue&type=style&index=0&id=23415126&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23415126",
  null
  
)

export default component.exports